<template>
  <q-page class="container" padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Estoque Atual</p>
    </div>
    <section>
      <component-superior
        v-if="highlights != ''"
        :sifraoPrimeiro="true"
        subPrimeiro="Total em estoque"
        :primeiro="highlights.total_em_estoque"
        subSegundo="Número total de produtos"
        :segundo="highlights.total_sku"
        subTerceiro="Com Estoque positivo"
        :terceiro="highlights.total_sku_em_estoque"
        subQuarto="Total de Itens"
        :quarto="highlights.total_itens"
      ></component-superior>
    </section>
    <section>
      <filtros-estoque-component
        @emitirFiltros="getFiltros"
      ></filtros-estoque-component>
    </section>
    <div class="row q-mt-lg justify-end">
      <q-btn
        label="Exportar"
        color="secondary"
        icon="file_upload"
        no-caps
        @click="exportar"
      />
    </div>
    <section class="q-mt-sm">
      <q-table
        flat
        :filter="filter"
        :title="'Estoque' + ' ' + total"
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        dense
        title-class="text-brand-5 text-weight-bold"
        :loading="disable"
        color="primary"
        :columns="columns"
        v-model:pagination="pagination"
        class="tabela q-mt-md tabela-tamanho-fixo"
        row-key="name"
        hide-pagination
        @focusin="activateNavigation"
        @focusout="deactivateNavigation"
        @keydown="onKey"
        @request="handleRequest"
      >
        <template v-slot:top-right>
          <q-input
            outlined
            rounded
            dense
            debounce="300"
            v-model="filter"
            placeholder="Search"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template #body-cell-imagem="props">
          <q-td>
            <q-img
              :src="props.row.imagem"
              style="max-width: 300px; height: 70px"
              fit="contain"
            >
            </q-img>
          </q-td>
        </template>
        <template #body-cell-movimento="props">
          <q-td>
            <q-btn
              class="q-mt-lg"
              color="positive"
              dense
              round
              icon="trending_up"
              @click="movimento(props.row.id_produto)"
            />
          </q-td>
        </template>

        <template #body-cell-preco_produto="props">
          <q-td>
            <span v-if="props.row.preco_produto"
              >R$ {{ props.row.preco_produto }}</span
            >
            <span v-else>R$ 00,00</span>
          </q-td>
        </template>

        <template #body-cell-total="props">
          <q-td>
            <span v-if="props.row.total">R$ {{ props.row.total }}</span>
            <span v-else>R$ 00,00</span>
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </section>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id_produto",
    label: "id",
    field: "id_produto",
    align: "left",
  },
  {
    name: "codigo_produto",
    label: "Código",
    field: "codigo_produto",
    align: "left",
  },
  {
    name: "descricao_do_produto",
    label: "Produto",
    field: "descricao_do_produto",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "imagem",
    label: "Imagem",
    field: "imagem",
    align: "left",
  },
  {
    name: "nome_grupo",
    label: "Grupo de Produto",
    field: "nome_grupo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "endereco",
    label: "Endereço",
    field: "endereco",
    align: "left",
  },
  {
    name: "codigo_ca",
    label: "ca",
    field: (row) =>
      row.codigo_ca_contrato == null ? row.codigo_ca : row.codigo_ca_contrato,
    align: "left",
  },
  {
    name: "categoria_codigo",
    label: "Categoria",
    field: "categoria_codigo",
    align: "left",
  },
  {
    name: "unidade_de_medida",
    label: "Unid. Medida",
    field: "unidade_de_medida",
    align: "left",
  },
  {
    name: "qtd_estoque",
    label: "Estoque",
    field: "qtd_estoque",
    align: "left",
  },
  {
    name: "qtd_machine",
    label: "Máquina",
    field: "qtd_machine",
    align: "left",
  },
  {
    name: "qtd_total_estoque",
    label: "Qtd. Total",
    field: "qtd_total_estoque",
    align: "left",
  },
  {
    name: "preco_produto",
    label: "R$ Unitário	",
    field: "preco_produto",
    align: "left",
  },
  {
    name: "total",
    label: "Total Estoque",
    field: "total",
    align: "left",
  },
  {
    name: "movimento",
    label: "Movimento",
    field: "movimento",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, computed, watch, onMounted } from "vue";
import filtrosEstoqueComponent from "../components/filtrosEstoqueComponent.vue";
import { useRouter } from "vue-router";
import ComponentSuperior from "../components/componentSuperior.vue";
export default {
  components: { filtrosEstoqueComponent, ComponentSuperior },
  setup() {
    const store = useStore();
    const router = useRouter();
    const rows = ref([]);
    const quasar = useQuasar();
    const disable = ref(true);
    const total = ref("");
    const filter = ref("");
    const unidadeDefault = ref("");
    const filtrosSave = ref();
    const highlights = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });

    const getDados = async (page = 0, rowsPerPage = 15, filtros) => {
      quasar.loading.show();
      try {
        let response = await store.dispatch("ind/getEstoque", {
          vendor_id:
            filtros && filtros.unidade
              ? filtros.unidade.id
              : unidadeDefault.value.id,
          product_group:
            filtros && filtros.produto ? filtros.produto : undefined,
          ordenar: filtros && filtros.order ? filtros.order.value : undefined,
          saldo: filtros && filtros.saldo ? filtros.saldo : undefined,
          page: page,
          perPage: rowsPerPage,
          product: filter.value,
        });

        rows.value = response.data.results.data;
        total.value = response.data.results.total;
        highlights.value = response.data.results.highlights;

        highlights.value?.total_em_estoque != null
          ? parseFloat(highlights.value?.total_em_estoque) >= 10
            ? highlights.value?.total_em_estoque?.slice(0, 10)
            : highlights.value?.total_em_estoque
          : 0;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;
        pagination.value.page = response.data.results.current_page;

        disable.value = false;
        quasar.loading.hide();
      } catch (error) {
        quasar.loading.hide();
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const exportar = async () => {
      try {
        await store.dispatch("ind/exportarEstoque", {
          vendor_id:
            filtrosSave.value && filtrosSave.value.unidade
              ? filtrosSave.value.unidade.id
              : unidadeDefault.value.id,
          product_group:
            filtrosSave.value && filtrosSave.value.produto
              ? filtrosSave.value.produto
              : undefined,
          ordenar:
            filtrosSave.value && filtrosSave.value.order
              ? filtrosSave.value.order.value
              : undefined,
          saldo:
            filtrosSave.value && filtrosSave.value.saldo
              ? filtrosSave.value.saldo
              : undefined,
          page: pagination.value.page,
          perPage: pagination.value.rowsPerPage,
          product: filter.value,
        });

        quasar.notify({
          message: "Exportado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      unidadeDefault.value = store.state.org.unidadeData;
      setTimeout(() => {
        getDados();
      }, 800);
    };
    onMounted(getUnidade);

    const handleRequest = async () => {
      getDados(
        pagination.value.page,
        pagination.value.rowsPerPage,
        filtrosSave.value
      );
    };

    const getFiltros = async (filtros) => {
      filtrosSave.value = filtros;
      getDados(1, pagination.value.rowsPerPage, filtrosSave.value);
    };

    const movimento = async (id) => {
      const routeData = router.resolve({
        name: "ind-estoque-movimento",
        params: { id: id },
      });
      window.open(routeData.href, "_blank");
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => filter.value,
      () => {
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidadeDefault.value = store.state.org.unidadeData;
      }
    );

    return {
      rows,
      columns,
      pagination,
      disable,
      getDados,
      handleRequest,
      exportar,
      total,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      getFiltros,
      filter,
      movimento,
      highlights,
      filtrosSave,
    };
  },
};
</script>

<style>
.q-table__top {
  padding: 12px 0px !important;
}
.titulo-tabela {
  font-size: 18px;
}

@media (max-width: 600px) {
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
}
</style>
